exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,button,div,h1,h2,h3,h4,h5,html,input,span{font-family:Product Sans,Arial,sans-serif!important}.material-icons{font-family:Material Icons!important}body,html{font-size:13px;line-height:20px;margin:0;height:100%;width:100%}body::-webkit-scrollbar{display:none}#app{height:100%}#app #container{height:inherit}[role=dialog] .appbar,[role=dialog] .toolbar{background-color:#009688}[role=dialog] .toolbar{display:flex;padding-right:0}[role=dialog] .toolbar h2{flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./app/style/style.scss
// module id = 783
// module chunks = 0